import { useSwrNoAuth } from "../swr/useSwrNoAuth";

export const useFetchRestaurantLogoByLineId = (restaurantId: string) => {
  const { data: logo, error, isLoading: isLoadingLogo } = useSwrNoAuth<string>(`accounts/restaurants/${restaurantId}/logo/`)
  return { logo, isLoadingLogo, error };
};